module.exports = __webpack_public_path__ + "static/media/Adam Richardson.1be03353.png";